import VueElementLoading from './index.vue'

export default VueElementLoading
